<div class="selector-idioma" role="group" [attr.aria-label]="t().etiqueta">
  <i class="pi pi-globe selector-idioma__icono" aria-hidden="true"></i>
  @for (opcion of idiomas; track opcion) {
    <button
      type="button"
      class="selector-idioma__opcion"
      [class.selector-idioma__opcion--activa]="opcion === idioma()"
      [attr.aria-pressed]="opcion === idioma()"
      [attr.lang]="opcion"
      [title]="nombreIdioma[opcion]"
      (click)="seleccionar(opcion)"
    >
      {{ opcion.toUpperCase() }}
    </button>
  }
</div>
